import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/sa/web-sa/header.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner banner_hire_sa"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Saudi Arabia">
                <h1>
                  Custom Software Development Company in
                  <span> Saudi Arabia</span>
                </h1>
              </div>
              <p className="main_para">
                Being one of the best custom software development companies in
                Saudi Arabia, we specialize in crafting innovative digital
                solutions by using web3, ML, AI, blockchain, and other modern
                technologies. TekRevol has a team of experienced developers
                dedicated to helping startups, and established organizations
                stay competitive by developing goals-oriented and innovative
                custom software and apps.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
